





































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, Pdi, VehicleLocation } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { IDialogOption } from '@/models/dialog';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class EditDevicePairCodePage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};

  public terminalModel: any = {
    code: '',
    deviceId: '',
    locationId: '',
    merchantId: '',
    name: '',
    status: '',
    typeId: '',
  };
  public selectedLocation: string = '';
  public form: any = {};
  public devicePairLocationFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public deviceId: string = '';
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;
  public deviceCode = '';
  public locationName = '';

  public showSelectStorePopup: IDialogOption = {
    width: 600,
    title: 'Terminal Device',
    model: false,
    loading: false,
    close: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('switchStoreDialog.btnText') as string,
    },
    onClose: (): void => {
      this.onClose();
    },
  };

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'SquareAccount' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(
          false,
          this.$t('stores.vehicleLocations.alertInvalidForm')
        );
        this.resetMethodName(methodName);
        return;
      }
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.setLocationFields();
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.deviceId = this.$route.params.devicepairId;
      this.getStoreInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setLocationFields(): void {
    this.devicePairLocationFields = [
      {
        key: 'name',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Device Name',
          counter: 30,
          loading: false,
          rules: [
            v => this.required('Device Name', v)
          ]
        },
      },
      {
        key: 'status',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: true,
          required: true,
          label: 'Status',
          counter: 30,
          loading: false,
          rules: [
            v => this.required('Status', v)
          ]
        },
      },
      {
        key: 'code',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: true,
          required: true,
          label: 'Device Code',
          counter: 30,
          loading: false,
          rules: [
            v => this.required('Device Code', v)
          ]
        },
      },
    ];
  }

  public onClose() {
    this.$router
      .push({
        name: 'admin.stores.edit',
        params: {
          tenantId: this.tenantId.toString(),
          enterpriseId: this.enterpriseId.toString(),
          storeId: this.storeId.toString(),
        },
      })
      .catch((ex) => {
        console.log(ex);
      });
  }

  public validateDeviceName(): Vue & { validate: () => boolean } {
    return this.$refs.deviceNameForm as Vue & { validate: () => boolean };
  }

  public async updateDeviceName(): Promise<void> {
    if (this.validateDeviceName().validate()) {
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (
          this.terminalModel.name == undefined ||
          this.terminalModel.name == ''
        ) {
          this.showAlert(false, 'Please Add Device Name');
          return;
        }
        const res = await storeService.updateDevicePairCodeName(
          this.terminalModel.deviceId,
          this.terminalModel.name,
          this.storeId
        );

        // if (res.status) {
        //   this.$router.back();
        // }
        this.$router.push({
          name: 'admin.stores.edit',
          params: {
            storeId: this.storeId.toString(),
            tab: 'SquareAccount'
          }
        });
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.devicePairLocationFields);
      const response = await storeService.getStore(this.storeId);
      this.storeViewModel = response;
      this.storeModel.id = this.storeViewModel.id;
      const squareLaneJson = [];
      this.terminalModel = response.squareLaneJson.filter(
        (x) => x.deviceId == this.deviceId
      )[0];
    } finally {
      this.formlyHideSkeleton(this.devicePairLocationFields);
    }
  }
}
